import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable }     from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import {Morto} from '../beans/morto';


@Injectable()
export class MortiService {


	private heroesUrl='api/morti';
	private headers = new Headers({'Content-Type': 'application/json'});


	constructor (private http:Http){}

	getMorti(): Promise<Morto[]> {
		return this.http.get(this.heroesUrl)
				.toPromise()
				.then(response=>response.json().data as Morto[])
				.catch(this.handleError);
	} 

	getMorto(id: number): Promise<Morto>{
		const url = `${this.heroesUrl}/${id}`;
		return this.http.get(url).toPromise().then(response=> response.json().data as Morto)
		.catch(this.handleError);
	}

	search(term: string): Observable<Morto[]> {
    return this.http
               .get(`api/morti/?name=${term}`)
               .map(response => response.json().data as Morto[]);
  }

private handleError(error: any){
	console.error('Error in libri app',error);
	return Promise.reject(error.message||error);
}



}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/services/morti.service.ts